export enum RockStatusCode {
  offTrack = '0000',
  onTrack = '0001',
  complete = '0002',
  canceled = '0003',
}

export const RockStatusCodeDisplayMap: Partial<Record<RockStatusCode, string>> = {
  [RockStatusCode.offTrack]: 'Off-Track',
  [RockStatusCode.onTrack]: 'On-Track',
  [RockStatusCode.complete]: 'Complete',
  [RockStatusCode.canceled]: 'Canceled',
};

export const RockStatusCodeClassNameDisplayMap: Partial<Record<RockStatusCode, string>> = {
  [RockStatusCode.offTrack]: 'off-track',
  [RockStatusCode.onTrack]: 'on-track',
  [RockStatusCode.complete]: 'complete',
  [RockStatusCode.canceled]: 'canceled',
};

export const RockStatusCodeIconDisplayMap: Partial<Record<RockStatusCode, string>> = {
  [RockStatusCode.onTrack]: 'assets/icons/thumbs-up--fill.svg',
  [RockStatusCode.offTrack]: 'assets/icons/thumbs-down--fill.svg',
  [RockStatusCode.complete]: 'assets/icons/check-circle--fill.svg',
  [RockStatusCode.canceled]: 'assets/icons/prohibit--duotone.svg',
};
